import React, { useEffect, useState } from "react";
import { MdAccessTime } from "react-icons/md";
import moment from "moment";
import { IoMdPricetags, IoMdTime } from "react-icons/io";
import {
  IoInformation,
  IoInformationCircle,
  IoPricetag,
} from "react-icons/io5";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { CurrencyFormatter, DateFormatter, TimeFormatter } from "../../helper/Formatter";
import swal from "sweetalert";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";

import "./bookingview.css";
import GuestForm from "../../pages/Bookings/components/GuestForm.js";
import { Carousel } from "react-bootstrap";
import RoomFile from "./Room/RoomFile.js";
import RoomPriceBreakDown from "./RoomPriceBreakDown.js";
import { FaArrowRight, FaCalendarAlt, FaCalendarTimes, FaTimes, FaUsers } from "react-icons/fa";
import Spinner from "../Spinner/index.js";
import { getDataServiceList } from "../../API/serviceApi.js";
import { getEachEventDetailService, getLoginDetailService } from "../../API/eventApi.js";
import { branchData, LoginService } from "../../API/loginApi.js";
import RechargeModal from "../Modal/RechargeModal/RechargeModal.js";
import { getPolicy } from "../../API/policyApi.js";
import { getCoupon } from "../../API/couponApi.js";
import { createGuestService } from "../../API/guest.js";
import { getBillCalculation } from "../../API/billDetailsApi.js";
import { getWallet } from "../../API/walletApi.js";
import CustModal from "../Modal/CustModal.js";
import LoginOtp from "../LoginOtp/index.js";

// async function getDataServiceList(id) {
//   const response = await commonService.commonGetMethod("services", id);
//   if (response?.data?.property?.onlineavailibility) {
//     return response.data;
//   } else {
//     return null;
//   }
// }

export default function BookingView(props) {
  let appStartData = props?.data
  let params = useParams();
  const LoginUserType = localStorage.getItem("LoginUserType");
  const existLoginUserType = localStorage.getItem("Exist");

  const location = useLocation();
  const navigate = useNavigate();
  const id = params.id;
  const CompanyName = localStorage.getItem("branchname");
  let userType = localStorage.getItem("LoginUserType");
  let locale = localStorage.getItem("Locale");
  let currency = localStorage.getItem("Currency");
  const loginUserId = localStorage.getItem("LoginUserId");
  const branchId = localStorage.getItem("branchid");
  const tabs = ["events", "room", "service"];
  const [formData, setFormData] = useState({
    password: "",
    email: "",
  });
  const [isLoading, setLoader] = useState(true);
  const [couponData, setCouponData] = useState([]);
  const [showSignIn, setShowSignIn] = useState(false);
  const [service, setServices] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const [selectedTime, setselectedTime] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoader, setIsLoader] = useState(false);
  const [allPayloadData, setAllPayloadData] = useState(location?.state?.data);

  const [walletAllData, setWalletAllData] = useState(null);
  const [showGuestModal, setShowGuestModal] = useState(false);

  const [showErr, setShowErr] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isGuestDetailsInfoExpanded, setIsGuestDetailsInfoExpanded] =
    useState(true);
  const [isBookingPolicyInfoExpanded, setIsBookingPolicyInfoExpanded] =
    useState(true);
  const [guestFormData, setGuestFormData] = useState({});
  const [storePolicyData, setStorePolicyData] = useState([]);
  const [bookData, setBookData] = useState(location?.state);
  const [typeModule, setTypeModule] = useState(location?.state?.type);
  const [guestDetails, setGuestDetails] = useState()
  const [bookDetailsData, setBookDetailsData] = useState({})
  const [loginMemberInfo, setLoginMemberInfo] = useState({})
  const [validateGuestForm, setValidateGuestForm] = useState(false);
  const [branchDataRes,setBranchDataRes] = useState(null)

  useEffect(() => {
    // console.log('as::: ');
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const startElement = document.getElementById("start");
    if (startElement) {
      startElement.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  useEffect(() => {
    async function onLoad(params) {
      try {
        setLoader(true);
        let payload = {
          "billdate": new Date(),
          // "customerid": "",
          "onModel": "",
          "property": {},
          "enddate": bookData?.data?.checkout,
          "startdate": bookData?.data?.checkin,
          services: bookData?.payload
        }
        const res = await getBillCalculation(payload)
        setBookDetailsData(res?.data)
        const branchRes = await branchData()
        setBranchDataRes(branchRes?.data?.[0])
      } catch (error) {
        setLoader(false);
        console.error("error::: ", error);
      } finally {
        setLoader(false);
      }
    }

    onLoad();
  }, []);


  const fetchLoginDetails = async (id, schemaName) => {
    try {
      setIsLoader(true);
      const { data } = await getLoginDetailService(schemaName, id);
      setFormData({
        fullName: data?.property?.fullname || "",
        email: data?.property?.primaryemail || "",
      });

      return data;
    } catch (error) {
      setIsLoader(false);
      console.error("Error fetching login details:", error);
    } finally {
      setIsLoader(false);
    }
  };

  const fetchData = async (apiCall, ...params) => {
    try {
      const response = await apiCall(...params);
      if (response?.status === 200 && response != null) {
        return response?.data;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    return null;
  };

  const getAllPolicy = async () => {
    return getPolicy();
  };

  const getAllCoupon = async () => {
    return getCoupon();
  };

  const getWalletPoint = async () => {
    return getWallet(loginUserId);
  };

  const LogInUser = async (loginData) => {
    let payload = {
      username: loginData.email,
      password: loginData.password,
      // branchid: branchId,
    };
    return LoginService(payload);
  };

  const dateoptions = {
    month: "long",
    year: "numeric",
  };

  useEffect(() => {
    const loadData = async () => {
      setLoader(true);

      try {
        if (typeModule === "service") {
          const services = await getDataServiceList(id);
          if (services?.data?.property?.onlineavailibility) {
            return services.data;
          } else {
            return null;
          }
          setServices(services);
          setBookData({ services, bookingtype: "service" });
          if (location?.state?.data?.selectedTime) {
            setselectedTime(location.state.data.selectedTime);
          }
        } else if (typeModule === "event") {
          const event = await getEachEventDetailService(id);
          setBookData({ event: event.data?.[0], bookingtype: "event" });
        }

      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        setLoader(false);
      }
    };

    loadData();

    return () => {
      setLoader(false);
      setServices(null);
    };
  }, []);

  useEffect(() => {
    const loadData = async () => {
      setIsLoader(true);
      try {
        const [couponData, policyData] = await Promise.all([
          fetchData(getAllCoupon),
          fetchData(getAllPolicy),
        ]);
        setCouponData(couponData);
        setStorePolicyData(policyData?.[0]);
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        setIsLoader(false);
      }
    };

    loadData();
  }, []);

  async function callWalletApi() {
    const res = await getWalletPoint(loginUserId);
    setWalletAllData(res?.data?.[0]);
  }

  useEffect(() => {
    if (loginUserId) {
      setDisabled(true);
      fetchLoginDetails(
        loginUserId,
        userType === "Prospects" ? "prospects" : "members"
      );
      callWalletApi();
    }
  }, [loginUserId, userType]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formData.email)
    ) {
      newErrors.email = "Invalid email address";
    }
    if (!formData.password.trim()) {
      newErrors.password = "Password is required";
    }
    return newErrors;
  };

  const handleLogInSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});
      try {
        const loginObj = await LogInUser(formData);
        setLoginMemberInfo(loginObj);
        if (
          loginObj.status === 200 &&
          loginObj.data?.error === undefined &&
          loginObj.data?.user?.status === "active"
        ) {
          toast.success("Login Successfully", { autoClose: 1000 });
          setIsLoader(true);
          // Store user data in localStorage and localStorage
          localStorage.setItem("Locale", loginObj.data.user.branchid.locale);
          localStorage.setItem(
            "Currency",
            loginObj.data.user.branchid.currency
          );
          localStorage.setItem("LoginUserId", loginObj.data.user._id);
          localStorage.setItem("LoginUserId", loginObj.data.user._id);
          localStorage.setItem(
            "LoginUserType",
            loginObj.data.usertype || "Member"
          );
          localStorage.setItem(
            "LoginUserType",
            loginObj.data.usertype || "Member"
          );
          localStorage.setItem("UserToken", loginObj.data.token);
          localStorage.setItem("UserToken", loginObj.data.token);
          localStorage.setItem("LoginUserName", loginObj.data.user.fullname);
          localStorage.setItem(
            "LoginAuth",
            `${window.location.pathname.split("/")[1]}_${loginObj.data.token}`
          );
          localStorage.setItem(
            "LoginAuth",
            `${window.location.pathname.split("/")[1]}_${loginObj.data.token}`
          );
          localStorage.setItem("data", JSON.stringify(loginObj.data));
          localStorage.setItem("data", JSON.stringify(loginObj.data));


          if (location.state.bookingtype === "room") {
            navigate(0);
          }



          const navigateTo = (path) => {
            setIsLoader(true);
            setTimeout(() => {
              navigate(path, {
                state: {
                  bookData,
                  customer: guestDetails || JSON.parse(localStorage.getItem("prospectdata")),
                  typeUser: localStorage.getItem("userType") || "Member",
                },
              });
            }, 1200);
          };

          if (bookData?.bookingtype === "event") {
            navigateTo(`/${CompanyName}/eventview/${id}`);
          } else if (bookData?.bookingtype === "service") {
            navigateTo(`/${CompanyName}/pricebreakdown/${id}`);
          }

        } else {
          if (loginObj.data?.user?.status !== "active") {
            toast.error("Email is not registered", {
              autoClose: 1000,
              backgroundColor: "red",
            });
          } else {
            toast.error(loginObj.data.error, {
              autoClose: 1000,
              backgroundColor: "red",
            });
          }
          // Handle unsuccessful login   or other states
          console.error(
            "Login failed:",
            loginObj.data?.error || "Unexpected error"
          );
        }
      } catch (error) {
        setIsLoader(false);
        console.error("Login error:", error);
      } finally {
        setIsLoader(false);
      }
    }
  };

  function handleAddWallet(params) {
    // console.log('params::: ', params);
    // setShowModal(true);
  }


  const handleGuestFormChange = (updatedData) => {
    // console.log('updatedData::: ', updatedData);
    setGuestFormData(updatedData);
  };

  const togglePolicyInfo = () => {
    setIsBookingPolicyInfoExpanded(!isBookingPolicyInfoExpanded);
  };

  async function handleContinue() {

    if (userType === "Member" || userType === "prospect") {
      const navigateTo = (path) => {
        setIsLoader(true);
        setTimeout(() => {
          navigate(path, {
            state: {
              bookData,
              customer: guestDetails || JSON.parse(localStorage.getItem("prospectdata")),
              typeUser: userType || "Member",
            },
          });
        }, 1200);
      };

      if (bookData?.bookingtype === "event") {
        navigateTo(`/${CompanyName}/eventview/${id}`);
      } else if (bookData?.bookingtype === "service") {
        navigateTo(`/${CompanyName}/pricebreakdown/${id}`);
      }


    } else {

      let payload = {
        property: { ...guestFormData, category: "Prospect" },
        category: "Prospect",
      };

      try {
        setIsLoader(true);
        const response = await createGuestService(payload);

        if (response?.status === 200) {
          toast.success("Registration Successfully", { autoClose: 1000 });
          setGuestDetails(response?.data);

          const data = response?.data;
          const category = data?.property?.category?.toLowerCase() || "prospect";

          // Local storage
          localStorage.setItem("prospectdata", JSON.stringify(data));
          localStorage.setItem("LoginUserType", category);
          localStorage.setItem("currency", data?.branchid?.currency);
          localStorage.setItem("locale", data?.branchid?.locale);

          // Session storage
          localStorage.setItem("LoginUserId", data?._id);
          localStorage.setItem("prospectdata", JSON.stringify(data));
          localStorage.setItem("LoginUserType", category);
          localStorage.setItem("currency", data?.branchid?.currency);
          localStorage.setItem("locale", data?.branchid?.locale);
          localStorage.setItem("fullname", data?.property?.fullname);




          if (bookData?.bookingtype === "event") {
            navigate(`/${CompanyName}/eventview/${id}`, {
              state: {
                bookData,
                customer: guestDetails || JSON.parse(localStorage.getItem("prospectdata")),
                typeUser: localStorage.getItem("typeuser"),
              },
            });
          } else {
            navigate(`/${CompanyName}/pricebreakdown/${id}`, {
              state: {
                bookData,
                customer: guestDetails || JSON.parse(localStorage.getItem("prospectdata")),
                typeUser: localStorage.getItem("typeuser"),
              },
            });
          }
        } else {
          toast.error(response?.data?.error || "Unexpected error", { autoClose: 1000 });
        }
      } catch (error) {
        toast.warn("Please login to continue", { autoClose: 1000 });
        console.error("error::: ", error);
      } finally {
        setIsLoader(false);
      }

      // } else {
      //   toast.warn("Please login to continue", { autoClose: 1000 });
      // }
    }
  }


  // function handleViewService() {
  //   if (loginUserId) {
  //     const data1 = {
  //       data: bookData,
  //     };
  //     navigate(`/${CompanyName}/pricebreakdown/${id}`, {
  //       state: data1,
  //     });
  //   } else {
  //     toast.warn("Please login to continue", {
  //       autoClose: 1000,
  //     });
  //   }
  // }

  // console.log('LoginUserType::: ', LoginUserType);
  return (
    <div id="start">
      {isLoader && <Spinner />}
      <main className="flex-shrink-0 position-relative ">
        <section className="common-block pb-3 m-0">
          <div className="container">
            <h3 className="card-title mb-4">
              Booking Information & User Details
            </h3>

            <div className="row mb-5">
              <div className="col-lg-8 mb-3 mb-lg-0">
                {loginUserId && userType === "Member" ? (
                  <div className="alert alert-success" role="alert">
                    <IoInformationCircle /> You are logged in as Member
                  </div>
                ) : loginUserId && LoginUserType === "Prospect"  ? (
                  <div className="alert alert-success" role="alert">
                    <IoInformationCircle /> You are logged in as Guest
                  </div>
                ) : (
                  <>
                    {appStartData?.property?.memberlogin && (
                      <p className="guest_info_sign_in_btn_container">
                        Already a member, Register here for
                        <button
                          disabled={loginUserId}
                          onClick={() => setShowSignIn(!showSignIn)}
                          className="btn font-16 btn-primary"
                        >
                          Sign in
                        </button>
                      </p>
                    )}
                    {appStartData?.property?.guestlogin && (
                      <div className="my-3">
                        Guest Information &nbsp;&nbsp;OR&nbsp;&nbsp;&nbsp;
                        <button
                          className="btn btn-secondary"
                          onClick={() => setShowGuestModal(true)}
                        >
                          Sign in to book faster
                        </button>
                      </div>
                    )}
                    {/* Sign-In Form */}
                    {showSignIn && !loginUserId && (
                      <div className="white-box background-transparent p-3 p-xl-4 mb-4">
                        <form
                          className="membroz-form wpcf7-form"
                          onSubmit={handleLogInSubmit}
                        >
                          <h5 className="mb-3">Enter Your Details</h5>
                          <div className="row">
                            <div className="col-lg-6 col-md-6">
                              <div className="form-group">
                                <input
                                  type="text"
                                  name="email"
                                  disabled={disabled}
                                  autoComplete="off"
                                  placeholder="Enter email"
                                  className={`form-control ${
                                    errors.email ? "is-invalid" : ""
                                  }`}
                                  value={formData.email}
                                  onChange={handleChange}
                                />
                                {errors.email && (
                                  <div className="invalid-feedback">
                                    {errors.email}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                              {loginUserId ? (
                                <div className="form-group">
                                  <input
                                    type="text"
                                    name="fullname"
                                    disabled={disabled}
                                    autoComplete="off"
                                    placeholder="Enter fullname"
                                    className="form-control"
                                    value={formData.fullName}
                                  />
                                </div>
                              ) : (
                                <div className="form-group">
                                  <input
                                    type="password"
                                    autoComplete="off"
                                    name="password"
                                    disabled={disabled}
                                    placeholder="Enter password"
                                    className={`form-control ${
                                      errors.password ? "is-invalid" : ""
                                    }`}
                                    value={formData.password}
                                    onChange={handleChange}
                                  />
                                  {errors.password && (
                                    <div className="invalid-feedback">
                                      {errors.password}
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-lg-12 col-md-12">
                            <div className="font-14 mb-3">
                              By proceeding, I agree to Hotel’s{" "}
                              <Link
                                to={`/${localStorage.getItem(
                                  "CompanyName"
                                )}/termsandcondition`}
                              >
                                Booking Terms & Conditions, Cancellation
                              </Link>
                              .
                            </div>
                            <button
                              type="submit"
                              disabled={disabled}
                              className="btn btn-primary btn-lg"
                            >
                              Sign in
                            </button>
                          </div>
                        </form>
                      </div>
                    )}
                  </>
                )}

                {appStartData?.property?.guestlogin === true && LoginUserType !== "Member" && existLoginUserType !== "Prospect"      && (
                  <div className="white-box background-transparent mb-4 p-xl-4">
                    <div className="membroz-form wpcf7-form">
                      <div
                        className="d-flex mb-3 justify-content-between align-items-center cursor-pointer"
                        onClick={() =>
                          setIsGuestDetailsInfoExpanded(
                            !isGuestDetailsInfoExpanded
                          )
                        }
                      >
                        <h5 className="">Guest Register here</h5>
                        <i
                          className={`fa icon_color ${
                            isGuestDetailsInfoExpanded
                              ? "fa-chevron-up"
                              : "fa-chevron-down"
                          }`}
                        />
                      </div>

                    </div>


                    {isGuestDetailsInfoExpanded && appStartData?.property?.guestlogin === true &&  (
                        <GuestForm
                          onGuestFormChange={handleGuestFormChange}
                          setValidateForm={setValidateGuestForm}
                        />
                      )}
                  </div>
                )}



                {bookData?.bookingtype === "room" && (
                  <RoomFile
                    bookDetailsData={bookDetailsData}
                    setShowErr={setShowErr}
                    showModal={showModal}
                    loginMemberInfo={loginMemberInfo}
                    guestFormData={{ ...guestFormData, type: "prospect" }}
                    validateGuestForm={validateGuestForm}
                  />
                )}
              </div>

              {bookData?.bookingtype === "service" && (
                <div className="col-lg-4 col-md-12">
                  <>
                    <div className="service-info-container">
                      <div className="service-info-content">
                        <div
                          className="service-info-header"
                          onClick={togglePolicyInfo}
                        >
                          <h5 className="service-info-title">
                            Service Information
                          </h5>
                          <i
                            className={`fa ${
                              isBookingPolicyInfoExpanded
                                ? "fa-chevron-up"
                                : "fa-chevron-down"
                            } service-info-icon`}
                          />
                        </div>

                        {isBookingPolicyInfoExpanded && (
                          <div className="service-info-body">
                            <div className="service-gallery">
                              {bookData?.services?.gallery?.length > 0 ? (
                                <Carousel>
                                  {bookData?.services?.gallery?.map(
                                    (item, index) => (
                                      <Carousel.Item key={index}>
                                        <img
                                          src={item?.attachment}
                                          className="gallery-image"
                                          alt="Gallery"
                                        />
                                      </Carousel.Item>
                                    )
                                  )}
                                </Carousel>
                              ) : (
                                <img
                                  src="/images/no-image.jpg"
                                  className="gallery-no-image"
                                  alt="No Image"
                                />
                              )}
                            </div>

                            <div className="service-details">
                              <h6 className="service-title">
                                {bookData?.services?.title}
                              </h6>
                              <ul className="service-details-list">
                                <li className="service-price">
                                  <IoPricetag className="price-icon" />
                                  <strong>Price: &nbsp;</strong>
                                  {CurrencyFormatter(
                                    bookData?.services?.charges || 0,
                                    locale || "en-IN",
                                    currency || "INR"
                                  )}
                                </li>

                                <li className="service-price">
                                  <IoMdTime className="price-icon" />
                                  <strong>Duration : &nbsp;</strong>
                                  {bookData?.services?.duration || 0} min
                                </li>
                              </ul>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </>

                  {/* {tabs.includes(location.state?.bookingtype) && (
                    <ServicePriceBreakDown
                      bookData={bookData}
                    />
                  )} */}
                  {(userType === "Member" ||
                    bookData?.bookingtype === "service") && (
                    <button
                      className="mt-2 btn w-100 font-20 font-weight-bold w-100 btn-primary "
                      onClick={handleContinue}
                    >
                      Continue
                    </button>
                  )}
                </div>
              )}

              {bookData?.bookingtype === "event" && (
                <div className="col-lg-4 col-md-12">
                  <>
                    <div className="service-info-container">
                      <div className="service-info-content">
                        <div
                          className="service-info-header"
                          onClick={togglePolicyInfo}
                        >
                          <h5 className="service-info-title">
                            Event Information
                          </h5>
                          <i
                            className={`fa ${
                              isBookingPolicyInfoExpanded
                                ? "fa-chevron-up"
                                : "fa-chevron-down"
                            } service-info-icon`}
                          />
                        </div>

                        {isBookingPolicyInfoExpanded && (
                          <div className="service-info-body">
                            <div className="service-gallery">
                              {bookData?.event?.property?.gallery?.length >
                              0 ? (
                                <Carousel>
                                  {bookData?.event?.property?.gallery?.map(
                                    (item, index) => (
                                      <Carousel.Item key={index}>
                                        <img
                                          src={item?.attachment}
                                          className="gallery-image"
                                          alt="Gallery"
                                        />
                                      </Carousel.Item>
                                    )
                                  )}
                                </Carousel>
                              ) : (
                                <img
                                  src="/images/no-image.jpg"
                                  className="gallery-no-image"
                                  alt="No Image"
                                />
                              )}
                            </div>

                            <div className="service-details">
                              <h6 className="service-title">
                                {bookData?.event?.title}
                              </h6>
                              <ul className="service-details-list">
                                <li className="service-price">
                                  <FaCalendarAlt className="price-icon" />
                                  <strong>Event Date :</strong>&nbsp;
                                  {DateFormatter(
                                    new Date(
                                      bookData?.event?.property?.startdate
                                    )
                                    //  "en-AU"
                                  )}
                                </li>

                                <li className="service-price">
                                  <MdAccessTime className="price-icon" />
                                  <strong>Event start time :</strong>&nbsp;
                                  {TimeFormatter(
                                    bookData?.event?.property?.starttime,
                                    locale
                                  )}
                                </li>

                                <li className="service-price">
                                  <FaCalendarTimes className="price-icon" />
                                  <strong>Registration End Date :</strong>&nbsp;
                                  {DateFormatter(
                                    new Date(
                                      bookData?.event?.property?.deadlinedate
                                    )
                                    //  "en-AU"
                                  )}
                                </li>

                                <li className="service-price">
                                  <FaUsers className="price-icon" />
                                  <strong>Event Type :</strong>&nbsp;
                                  {bookData?.event?.property?.eventtype}
                                </li>

                                <li className="service-price">
                                  <IoMdPricetags className="price-icon" />
                                  <strong>Event Fees :</strong>&nbsp;
                                  {bookData?.event?.property?.eventfee}
                                </li>
                              </ul>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </>

                  {/* {tabs.includes(location.state?.bookingtype) && (
                    <ServicePriceBreakDown
                      bookData={bookData}
                    />
                  )} */}
                  {(userType === "Member" ||
                    bookData?.bookingtype === "service" ||
                    bookData?.bookingtype === "event") && (
                    <button
                      className="mt-2 btn w-100 font-20 font-weight-bold w-100 btn-primary "
                      onClick={handleContinue}
                    >
                      Continue
                    </button>
                  )}
                </div>
              )}

              {bookData?.bookingtype === "room" && (
                <div className="col-lg-4 col-md-12">
                  <RoomPriceBreakDown
                  appStartData={appStartData}
                  branchDataRes={branchDataRes}
                    bookDetailsData={bookDetailsData}
                    walletAllData={walletAllData}
                    showErr={showErr}
                    // handleAddWallet={handleAddWallet}
                    allPayloadData={allPayloadData}
                    checkinDate={allPayloadData?.checkin}
                    checkOutDate={allPayloadData?.checkout}
                  />
                </div>
              )}
            </div>
          </div>
        </section>
      </main>

      <CustModal
        footerBtn={false}
        backdrop={true}
        modalWidthSize={"lg"}
        show={showGuestModal}
        handleClose={() => {
          setShowGuestModal(false);
          localStorage.removeItem("fullname");
          localStorage.removeItem("LoginUserId");
          localStorage.removeItem("usertype");
          localStorage.removeItem("primaryemail");
          localStorage.removeItem("userData");
        }}
        title="Login as a guest"
        body={<LoginOtp />}
        footerBtnName="Close"
      />

      <CustModal
        footerBtn={false}
        modalWidthSize={"lg"}
        show={showModal}
        handleClose={() => setShowModal(false)}
        title="Recharge Wallet"
        body={
          <RechargeModal
            setShowModal={setShowModal}
            // handleWalletRechargeSubmit={handleWalletRechargeSubmit}
          />
        }
        footerBtnName="Close"
      />
    </div>
  );
}
